import "./Scroll.scss"
import { withRouter } from "react-router-dom"
import React, { Component, PropTypes } from "react"
import classnames from "classnames"

class Scroll extends Component {
  constructor(props) {
    super(props)
    this.scrollTo = this.scrollTo.bind(this)
  }

  getChildContext() {
    return {
      scrollTo: this.scrollTo,
    }
  }

  scrollTo(to, duration = 300) {
    if (!this.el) return null
    const from = this.el.scrollTop
    const dist = to - from
    let start
    const animateScroll = timestamp => {
      if (!start) {
        start = timestamp
      }
      const time = timestamp - start || 0
      const travel = time / duration * dist
      this.el.scrollTop = from + travel
      if (time < duration) {
        window.requestAnimationFrame(animateScroll)
      }
    }
    window.requestAnimationFrame(animateScroll)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      if (nextProps.resetOnRouteChange) {
        this.scrollTo(0, 0)
      }
    }
  }

  render() {
    const { vertical, horizontal, style, children, className } = this.props

    const styles = Object.assign(
      {
        overflowX: horizontal ? "auto" : "hidden",
        overflowY: vertical ? "auto" : "hidden",
      },
      style
    )

    return (
      <div
        ref={el => {
          this.el = el
        }}
        className={classnames("Scroll", className)}
        style={styles}>
        {children}
      </div>
    )
  }
}

Scroll.displayName = "Scroll"

Scroll.childContextTypes = {
  scrollTo: PropTypes.func,
}

Scroll.propTypes = {
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
}

Scroll.defaultProps = {
  horizontal: false,
  vertical: true,
}

export default withRouter(Scroll)



// WEBPACK FOOTER //
// ./src/lib/Scroll.js